import api from "../api/index.js";
import axios from 'axios'
import config from '../config.js'
const siteConfig = config[process.env.NODE_ENV]
export default {
  methods: {
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        axios.post(`${siteConfig.fileStorageApi}/getPolicy`, {
          fileName: file.name,
          maxSize: this.maxSize || 1024 * 1024 * 15,
          fileType: this.fileType,
          filePath: 'unicapsule'
        }).then(res => {
          this.uploadApi = res.data.ossHost;
          this.data = {
            ossAccessKeyId: res.data.ossAccessKeyId,
            policy: res.data.policy,
            signature: res.data.signature,
            key: res.data.key,
            success_action_status: "200",
            fileType: this.fileType
          };
          file.ossUrl = res.data.url;
          file.id = res.data.id;
          this.$nextTick(() => {
            resolve(res.data.url);
          });
        }).catch(err => {
          reject(err);
          console.log(err);
        })
      });
    }
  }
};
